export const FLAG_GETTING_SECURITY_PROFILES = 'FLAG_GETTING_SECURITY_PROFILES';
export const GET_SECURITY_PROFILES = 'GET_SECURITY_PROFILES';
export const CLEAR_SECURITY_PROFILES = 'CLEAR_SECURITY_PROFILES';
